<template>
    <g id="tea--anim"  class="tea--main">
        <path class="tea--border" fill="#FFDA44" d="M177.8,151.1v-16.6h-39.3h-15.1h-9.1H99.1v93.8h39.3h39.3v-19.7c15.9,0,28.8-12.9,28.8-28.8
	S193.7,151.1,177.8,151.1z M177.8,199.6v-39.3c10.8,0,19.7,8.8,19.7,19.7C197.5,190.7,188.7,199.6,177.8,199.6z"/>
        <g id="XMLID_1175_">
            <path id="XMLID_1185_" fill="#FF5023" d="M177.8,151.1v-16.6h-39.3v93.8h39.3v-19.7c15.9,0,28.8-12.9,28.8-28.8
		S193.7,151.1,177.8,151.1z M177.8,199.6v-39.3c10.8,0,19.7,8.8,19.7,19.7C197.5,190.7,188.7,199.6,177.8,199.6z"/>
            <path id="XMLID_1188_" fill="#FF9811" d="M123.4,134.5v36.3h-9.1v-36.3H99.1v93.8h39.3v-93.8H123.4z M129.4,195h-21.2v-17l6.1-7.3
		h9.1l6.1,7.3V195z"/>
            <polygon id="XMLID_1191_" fill="#FFFFFF" points="114.3,170.8 108.2,178.1 108.2,195 129.4,195 129.4,178.1 123.4,170.8 	"/>
            <rect id="XMLID_1192_" x="114.3" y="134.5" fill="#FFDA44" width="9.1" height="36.3"/>
        </g>
    </g>
</template>

<script>
    import { TimelineMax, Power0 } from 'gsap'

    export default {
        methods: {
            crash() {
                const tl = new TimelineMax();
                tl.to('#tea--anim',0.5,{rotation:270, ease: Power0.easeNone, transformOrigin:"center", y:'400'});
            },
        }
    }

</script>

<style lang="scss">

    .tea--main {

        &:hover .tea--border{
            stroke: yellow;
            stroke-width: 20;
        }
    }

</style>
